<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="submission">
            <div
                class="form-group fv-plugins-icon-container dm-share-history-radio"
            >
                <label>{{
                    translate(
                        "Do you wish to share your Manuscript Submission History?",
                    )
                }}</label>

                <div class="radio-inline">
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios1"
                            :value="false"
                            v-model="submission.history_share"
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("No") }}
                    </label>
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios1"
                            :value="true"
                            v-model="submission.history_share"
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("Yes") }}
                    </label>
                </div>
            </div>

            <div
                class="form-group fv-plugins-icon-container dm-submitted-elsewhere-radio"
                v-if="submission.history_share"
            >
                <label>{{
                    translate(
                        "Have you submitted this Manuscript to other Companies?",
                    )
                }}</label>

                <div class="radio-inline">
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios2"
                            :value="false"
                            v-model="submission.history_submitted_elsewhere"
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("No") }}
                    </label>
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios2"
                            :value="true"
                            v-model="submission.history_submitted_elsewhere"
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("Yes") }}
                    </label>
                </div>
            </div>

            <div
                class="form-group fv-plugins-icon-container dm-is-under-submission-elsewhere-radio"
                v-if="
                    submission.history_share &&
                    submission.history_submitted_elsewhere
                "
            >
                <label>{{
                    translate(
                        "Is it currently under submissions with anyone else?",
                    )
                }}</label>

                <div class="radio-inline">
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios3"
                            :value="false"
                            v-model="
                                submission.history_is_under_submission_elsewhere
                            "
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("No") }}
                    </label>
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios3"
                            :value="true"
                            v-model="
                                submission.history_is_under_submission_elsewhere
                            "
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("Yes") }}
                    </label>
                </div>
            </div>
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    mixins: [validationMixin],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "submission",
            "bottom_navigation_rules",
        ]),
        isValid() {
            if (!this.submission) return false;
            if (this.submission.history_share === false) return true;
            if (this.submission.history_submitted_elsewhere === false)
                return true;
            if (this.submission.history_is_under_submission_elsewhere === null)
                return false; // This is the initial state.

            return true;
        },
    },
    watch: {
        isValid: function (newValue, oldValue) {
            this.validateAndSave();
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),

        validateAndSave() {
            this.validate();

            if (this.isValid) this.saveSubmission();
        },
    },
};
</script>
